import { Headline5 } from './../../../common/typography';
import styled from 'styled-components';

export const StyleSummaryCardContainer = styled.div`
  display: flex;
  flex-direction: column;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.1);
  border-radius: ${({ theme }) => theme.radius.s};
  padding: ${({ theme }) => theme.spacing.m};
`;

export const SummaryCardTitle = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.sm};
`;

export const SummaryCardTitleDepartment = styled.span`
  font-size: ${({ theme }) => theme.fontSize.h4};
  font-weight: ${({ theme }) => theme.fontWeight.semiBold};
  color: ${({ theme }) => theme.colors.eerieBlack};
`;

export const SummaryCardSection = styled.span`
  font-size: ${({ theme }) => theme.fontSize.h4};
  font-weight: ${({ theme }) => theme.fontWeight.regular};
  color: ${({ theme }) => theme.colors.dimGray};
`;

export const SummaryDataContainer = styled.div`
  display: flex;
  align-items: center;

  & .donut-circle-bg {
    stroke-width: 5;
    stroke: ${({ theme }) => theme.colorsInObjects.gray[600]};
  }

  & .donut-circle-value {
    stroke-width: 5;
  }
`;

export const SummaryInfosContainer = styled.div`
  width: ${({ theme }) => theme.width.full};
  margin-left: ${({ theme }) => theme.spacing.md};
`;

export const SummaryInfosTextContainer = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.sm};
`;

export const SummaryInfosTitlesContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const SummaryInfosTitle = styled(Headline5)`
  margin-bottom: ${({ theme }) => theme.spacing.s};
  color: ${({ theme }) => theme.colors.eerieBlack};
`;

export const SummaryActionsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;

export const EditButtonWrapper = styled.button`
  padding: ${({ theme }) => theme.spacing.none};
  width: ${({ theme }) => theme.spacing.l};
  height: ${({ theme }) => theme.spacing.l};
  background-color: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colorsInObjects.gray[600]};
  margin-right: ${({ theme }) => theme.spacing.xs};
  border-radius: ${({ theme }) => theme.radius.xs};
`;

export const DeleteButtonWrapper = styled.button`
  padding: ${({ theme }) => theme.spacing.none};
  width: ${({ theme }) => theme.spacing.l};
  height: ${({ theme }) => theme.spacing.l};
  background-color: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colorsInObjects.gray[600]};
  border-radius: ${({ theme }) => theme.radius.xs};
`;

export const DonutContainer = styled.div`
& svg,
& span {
  transform: translate(-3.5px, 0);
}
`;
